// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuetify from 'vuetify'
import VueTour from 'vue-tour'
import 'babel-polyfill'
import router from './router';
//import { VueExtendLayout, layout } from 'vue-extend-layout';
import Tooltip from 'vue-directive-tooltip';
import VeeValidate, {Validator} from 'vee-validate';

import "./quilljs";

import 'vue-directive-tooltip/css/index.css';
import 'vue-tour/dist/vue-tour.css';
// index.js or main.js
// import 'vuetify/dist/vuetify.min.css'

import { ambiente } from './environment';
// import language from './helpers/language';

import LocalStorage from './helpers/localstorage'
import money from 'v-money';

import VueSwal from 'vue-swal'
Vue.use(VueSwal)

Vue.use(money, {
    precision: 2,
    thousands: '.',
    masked: false,
    decimal: ','
})

import extenso from 'extenso';



Vue.prototype.$localStorage = new LocalStorage('JSON_STORAGE');

// The plugin is loaded here.
// Vue.use(MyPlugin)


const plugin = {
    install(Vue, options) {
        Vue.prototype.$ambiente = ambiente;
    }
};
Vue.use(plugin);

Validator.localize('pt_BR', require('vee-validate/dist/locale/pt_BR'));
Vue.use(VeeValidate, {
    locale: 'pt_BR',
    dictionary: {
        pt_BR:{
            attributes: {
                pessoa_nome: 'nome',
                pessoa_profissao: 'profissão',
                pessoa_celular: 'celular',
                pessoa_telefone: 'telefone',
                pessoa_cpf: 'CPF',
                pessoal_sexo: 'Sexo',
                pessoa_data_nascimento: 'Data de Nascimento',


            }
        }
    }
});


VeeValidate.Validator.extend('fixo', {
    getMessage: field => 'Telefone inválido',
    validate: value => {
        const tel = value.replace(/\D+/g, '').replace('1111111111','');
        if(tel.length < 10) return false;
        return tel.substr(3, 1) < 6;
    }
});

VeeValidate.Validator.extend('celphone', {
    getMessage: field => 'Celular inválido',
    validate: value => {
        const tel = value.replace(/\D+/g, '').replace('1111111111','');
        if(tel.length < 10) return false;
        return tel.substr(2, 1) > 5;
    }
});

VeeValidate.Validator.extend('mydata', {
    getMessage: field => 'Data inválida',
    validate: value => {
        const dt = moment(moment(value, 'DD/MM/YYYY'));
        const age = moment().diff(dt, 'years');
        return age < 150;

    }
});

Vue.use(VueTour)
Vue.use(Vuetify);
Vue.use(Tooltip, {
    delay: 50,
    placement: 'top',
    class: 'tooltip-red',
    triggers: ['hover'],
    offset: 0
});
Vue.config.productionTip = false;

//Vue.use(VueExtendLayout);

Vue.filter('phone', function(value) {
    if (value !== null && value.length === 11) {
        return '('+value.substr(0,2)+') '+value.substr(2,5)+'-'+value.substr(7,4);
    } else if (value !== null && value.length === 10) {
        return '('+value.substr(0,2)+') '+value.substr(2,4)+'-'+value.substr(6,4);
    } else {
        return value;
    }
});

Vue.filter('cpf', function(value) {
    if (value !== null && value.length === 11) {
        return value.substr(0,3)+'.'+value.substr(3,3)+'.'+value.substr(6,3)+'-'+value.substr(9,2);
    } else {
        return value;
    }
});

Vue.filter('formatDateHour', function(value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY hh:mm')
    }
});

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
    }
});

Vue.filter('dataBr', function(value) {
    if (value !== null && moment(value).isValid()) {
        return moment(value).format('DD/MM/YYYY');
    } else {
        return value;
    }
});

Vue.filter('genero', function(value) {
    if (value === 'M') {
        return 'Masculino';
    } else {
        return 'Feminino';
    }
});

Vue.filter('estadoCivil', function(value) {
    if (value === 'C') {
        return 'Casado';
    } else if (value === 'D') {
        return 'Divorciado';
    } else if (value === 'V') {
        return 'Viúvo';
    } else {
        return 'Solteiro';
    }
});

Vue.filter('dinheiro', function (valor) {

    let num = parseFloat(valor);

    const texto = isNaN(num) ? '0,00' : num.toFixed(2).replace('.', ',');

    let partes = texto.toString().split(".");

    partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    return `R$ ${partes.join(",")}`;
});

Vue.filter('dinheiro_extenso', function (val) {

    const moeda = val.toFixed(2).replace('.',',')

    const money = extenso(moeda , { mode: 'currency', currency: { type: 'BRL' } })

    return money
});


Vue.filter('cep', (cep) => {

    if (typeof cep == 'string') {
        return `${cep.substr(0, 2)}.${cep.substr(2, 3)}-${cep.substr(5, 8)}`;
    }

    return cep;

});

Vue.filter('capitalize', (value) => {
    value = value.toLowerCase()
    return value.replace(/(?:^|\s|-)\S/g, x => x.toUpperCase());
})


// Datepicker
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/pt-br';
import DatePicker from "vue2-datepicker";

Vue.component('date-picker', DatePicker);
Vue.component('pagination', require('laravel-vue-pagination'));

import App from "./App"

const app = new Vue({
    el: '#app',
    router,
    //...layout,

    render: (h) => h(App)
});

window.app = app;

window['moment-range'].extendMoment(moment);



// WEBPACK FOOTER //
// ./src/main.js